var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({class:`common-btn text-subtitle-2 ${_vm.btnStyle}`,attrs:{"elevation":_vm.elevation,"href":_vm.href,"target":_vm.target,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('onButtonClick')}}},'v-btn',_vm.$attrs,false),[_vm._t("icon"),_vm._t("default"),_c('div',{staticClass:"text-body-2",style:({
      color: _vm.btnStyle === 'default' ? 'black' : ''
    })},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }